function extras(bg, ecom, keywords) {
  return { bg: bg, ecom: ecom, keywords: keywords }
}

function kw(bg, ecom) {
  return {
    'ai-background-remover-online': bg,
    'ecommerce-product-background-removal': ecom
  }
}

function bgStruct(pack) {
  return {
    sec: {
      tldrExtraRows: [[pack.bestForLabel, pack.bestForValue]],
      galleryCaption: pack.galleryCaption,
      howTipTitle: pack.howTipTitle,
      howTipText: pack.howTipText,
      troubleExtraRows: [[pack.blurLabel, pack.blurCause, pack.blurFix]],
      troubleTipTitle: pack.troubleTipTitle,
      troubleTipText: pack.troubleTipText,
      intentsTitle: pack.intentsTitle
    },
    extraScenarios: pack.extraScenarios
  }
}

function ecomStruct(pack) {
  return {
    sec: {
      tldrExtraRows: [[pack.freeLabel, pack.freeKeep, pack.freeCheck]],
      galleryCaption: pack.galleryCaption,
      platExtraRows: [[pack.indieLabel, pack.indieUse, pack.indieNote]],
      platTipTitle: pack.platTipTitle,
      platTipText: pack.platTipText,
      casesP: pack.casesP,
      acceptTipTitle: pack.acceptTipTitle,
      acceptTipText: pack.acceptTipText,
      intentsTitle: pack.intentsTitle
    },
    extraScenarios: pack.extraScenarios
  }
}

module.exports = {
  ja: extras(
    bgStruct({
      bestForLabel: '向いている内容',
      bestForValue: 'ポートレート、アバター、商品、ロゴ、署名、ペット写真',
      galleryCaption: '左が元画像、右が背景除去後の例。最終ファイルは透明 PNG でダウンロードします。',
      howTipTitle: 'シャープな輪郭を残す',
      howTipText: '何度も圧縮した画像は避け、できるだけオリジナルをアップロードします。小さいスクリーンショット、ブレ、被写体と背景の同色はエッジ検出を難しくします。',
      blurLabel: '結果がぼやけて見える',
      blurCause: 'サムネイルや再圧縮画像をアップロードした',
      blurFix: 'カメラ原版やより高解像度のファイルで再処理する',
      troubleTipTitle: '再試行のポイント',
      troubleTipText: '白縁、消えた髪、欠けた透明物体が出たら、同じ低解像度ファイルを何度も出すより、入力画像を改善してください。',
      intentsTitle: 'よくある処理シーン',
      extraScenarios: [
        { title: '無料でオンライン切り抜き', text: 'JPG / PNG / WebP をアップロードし、自動検出後に透明 PNG をダウンロードします。' },
        { title: '髪の毛の切り抜き', text: '鮮明な原版を使い、細い髪を明るいキャンバスと暗いキャンバスの両方で確認します。' },
        { title: '白縁を直す', text: '透明 PNG を暗いキャンバスに置き、よりコントラストの強い原版で再試行します。' },
        { title: 'Photoshop なしで切り抜き', text: '手描きのペンツールは不要です。AI が前景を検出し、背景全体を除去します。' },
        { title: 'JPG を透明 PNG にする', text: 'JPG は透明度を持てません。除去後は必ず PNG で保存します。' },
        { title: '透明と白背景の違い', text: '透明 PNG に固定色はありません。白背景画像はすでに白いピクセルを含みます。' },
        { title: 'スマホ写真の背景除去', text: '可能ならカメラ原版を使います。チャット圧縮されたサムネイルは髪やガラスに不利です。' },
        { title: '証明写真の背景', text: 'まず透明 PNG を作り、必要な白または指定色のキャンバスをあとから敷きます。' },
        { title: '15 MB を超える画像', text: '先に圧縮してからアップロードします。現在のページは 1 枚ずつ処理します。' }
      ]
    }),
    ecomStruct({
      freeLabel: '無料処理',
      freeKeep: 'サインイン後に Miral AI Background Remover を使う',
      freeCheck: 'ソフトのインストールは不要。まず透明 PNG マスターを作る',
      galleryCaption: '商品素材の処理前後。透明 PNG は白背景図とシーン図の共通マスターになります。',
      indieLabel: '越境 / 自社サイト',
      indieUse: '多言語商品ページと広告画像',
      indieNote: '1 枚の透明 PNG マスターからサイズを派生させる',
      platTipTitle: 'プラットフォーム要件',
      platTipText: '背景除去はクリーンな素材を作るだけで、最新の出品ルール準拠を自動保証しません。公開前に対象チャネルの公式要件を確認してください。',
      casesP: '素材によって失敗箇所は違います。服は毛羽、ジュエリーは細鎖、ガラスは透明部、電子機器は端子と反射を見ます。サムネイルだけで判断せず、100% 表示で明暗 2 色のキャンバスを確認してください。',
      acceptTipTitle: 'マスター管理',
      acceptTipText: '店舗画像の背景を揃えるときは、先にきれいな透明 PNG を保存します。白、ブランド色、キャンペーンシーンはそこから派生させ、切り抜きをやり直さないでください。',
      intentsTitle: 'よくある処理シーン',
      extraScenarios: [
        { title: 'ガラス商品の欠け', text: 'コントラストの強い原版に替え、透明部を白と暗の両方で目視確認します。' },
        { title: '商品切り抜きの白縁', text: '透明 PNG を暗いキャンバスに置き、より高解像でコントラストの強い商品原版で再試行します。' },
        { title: '1 枚の PNG を複数モールで使う', text: 'マスターは共用し、最終のサイズ・余白・背景はチャネルごとに書き出します。' },
        { title: '切り抜きからライフスタイル画像へ', text: '透明 PNG を Seedream または FLUX に渡し、形・色・ロゴが変わっていないか確認します。' },
        { title: '一括カタログ処理は？', text: '現在は 1 枚ずつです。細鎖、ガラス、毛は特に逐次確認してください。' },
        { title: '服と靴ひもの確認', text: '輪郭と交差する靴ひもを追い、メッシュや靴ひもが切れていないか確認します。' },
        { title: '白版と透明マスターの分け方', text: '先に透明マスターを残し、白が必要なときだけ別書き出しします。白版でマスターを上書きしないでください。' }
      ]
    }),
    kw(
      ['無料 AI 背景除去', 'オンライン切り抜き', '透明 PNG', '人物切り抜き', '髪の毛切り抜き', 'ロゴ背景除去'],
      ['商品画像の背景除去', 'EC 白背景', 'Amazon 白背景', 'Shopify 透明商品画像', 'eBay 商品切り抜き', 'Etsy 背景除去']
    )
  ),
  ko: extras(
    bgStruct({
      bestForLabel: '적합한 내용',
      bestForValue: '인물, 아바타, 상품, 로고, 서명, 반려동물 사진',
      galleryCaption: '왼쪽은 원본, 오른쪽은 배경 제거 후 예시입니다. 최종 파일은 투명 PNG로 다운로드합니다.',
      howTipTitle: '선명한 윤곽 유지',
      howTipText: '여러 번 압축된 이미지보다 원본을 올리세요. 작은 스크린샷, 흔들림, 피사체와 배경이 비슷한 색은 가장자리 검출을 어렵게 합니다.',
      blurLabel: '결과가 흐릿해 보임',
      blurCause: '썸네일이나 재압축 이미지를 업로드함',
      blurFix: '카메라 원본이나 더 높은 해상도 파일로 다시 처리',
      troubleTipTitle: '재시도 포인트',
      troubleTipText: '흰 테두리, 사라진 머리카락, 빠진 투명 물체가 보이면 같은 저해상도 파일을 반복하기보다 입력 이미지를 개선하세요.',
      intentsTitle: '자주 쓰는 처리 장면',
      extraScenarios: [
        { title: '무료 온라인 누끼', text: 'JPG / PNG / WebP를 올리고 자동 검출 후 투명 PNG를 받습니다.' },
        { title: '머리카락 누끼', text: '선명한 원본을 쓰고 가는 머리카락을 밝은 캔버스와 어두운 캔버스에서 확인하세요.' },
        { title: '흰 테두리 고치기', text: '투명 PNG를 어두운 캔버스에 놓고 대비가 더 강한 원본으로 다시 시도합니다.' },
        { title: '포토샵 없이 누끼', text: '펜 툴이 필요 없습니다. AI가 전경을 찾고 배경 전체를 제거합니다.' },
        { title: 'JPG를 투명 PNG로', text: 'JPG는 투명도를 저장하지 못합니다. 제거 후에는 PNG로 저장하세요.' },
        { title: '투명과 흰 배경의 차이', text: '투명 PNG에는 고정 색이 없습니다. 흰 배경 이미지는 이미 흰 픽셀을 포함합니다.' },
        { title: '휴대폰 사진 배경 제거', text: '가능하면 카메라 원본을 쓰세요. 채팅 압축 썸네일은 머리카락과 유리에 불리합니다.' },
        { title: '증명사진 배경', text: '먼저 투명 PNG를 만든 뒤 필요한 흰색 또는 지정 색 캔버스를 깔세요.' },
        { title: '15MB 초과 이미지', text: '먼저 압축한 뒤 업로드하세요. 현재 페이지는 한 장씩 처리합니다.' }
      ]
    }),
    ecomStruct({
      freeLabel: '무료 처리',
      freeKeep: '로그인 후 Miral AI Background Remover 사용',
      freeCheck: '별도 소프트웨어 불필요. 먼저 투명 PNG 마스터를 만듭니다',
      galleryCaption: '상품 소재 처리 전후. 투명 PNG는 흰 배경과 장면 이미지의 공통 마스터입니다.',
      indieLabel: '해외 / 자사 몰',
      indieUse: '다국어 상품 페이지와 광고 이미지',
      indieNote: '하나의 투명 PNG 마스터에서 크기를 파생',
      platTipTitle: '플랫폼 요건',
      platTipText: '배경 제거는 깨끗한 소재를 만들 뿐 최신 등록 규칙을 자동 보장하지 않습니다. 게시 전 해당 채널 공식 요건을 확인하세요.',
      casesP: '소재마다 실패 지점이 다릅니다. 옷은 보풀, 주얼리는 가는 체인, 유리는 투명 영역, 전자기기는 단자와 반사를 보세요. 썸네일만 보지 말고 100%에서 밝고 어두운 캔버스로 확인하세요.',
      acceptTipTitle: '마스터 관리',
      acceptTipText: '스토어 이미지 배경을 맞출 때는 깨끗한 투명 PNG를 먼저 저장하세요. 흰색, 브랜드색, 캠페인 장면은 여기서 파생하고 누끼를 반복하지 마세요.',
      intentsTitle: '자주 쓰는 처리 장면',
      extraScenarios: [
        { title: '유리 상품이 빠짐', text: '대비가 강한 원본으로 바꾸고 투명 부분을 흰/어두운 배경에서 확인합니다.' },
        { title: '상품 누끼 흰 테두리', text: '투명 PNG를 어두운 캔버스에 놓고 더 선명하고 대비가 강한 상품 원본으로 다시 시도합니다.' },
        { title: '한 PNG를 여러 몰에서', text: '마스터는 공유하고 최종 크기·여백·배경은 채널별로 보냅니다.' },
        { title: '누끼 후 라이프스타일 이미지', text: '투명 PNG를 Seedream 또는 FLUX로 넘기고 형태·색·로고가 유지됐는지 확인합니다.' },
        { title: '카탈로그 일괄 처리?', text: '현재는 한 장씩입니다. 가는 체인, 유리, 털은 특히 하나씩 확인하세요.' },
        { title: '옷과 신발 끈 확인', text: '윤곽과 교차하는 끈을 따라 메쉬나 끈이 잘리지 않았는지 확인합니다.' },
        { title: '흰 배경과 투명 마스터 나누기', text: '먼저 투명 마스터를 남기고, 흰 배경이 필요할 때만 따로 보냅니다. 흰 버전으로 마스터를 덮지 마세요.' }
      ]
    }),
    kw(
      ['무료 AI 배경 제거', '온라인 누끼', '투명 PNG', '인물 배경 제거', '머리카락 누끼', '로고 배경 제거'],
      ['상품 이미지 배경 제거', '이커머스 흰 배경', 'Amazon 흰 배경', 'Shopify 투명 상품 이미지', 'eBay 상품 누끼', 'Etsy 배경 제거']
    )
  ),
  fr: extras(
    bgStruct({
      bestForLabel: 'Idéal pour',
      bestForValue: 'Portraits, avatars, produits, logos, signatures, photos d’animaux',
      galleryCaption: 'À gauche l’original, à droite l’exemple après suppression. Le fichier final se télécharge en PNG transparent.',
      howTipTitle: 'Garder des contours nets',
      howTipText: 'Uploadez l’original plutôt qu’une image recompressée. Miniatures, flou et couleurs trop proches rendent les bords plus difficiles.',
      blurLabel: 'Le résultat paraît flou',
      blurCause: 'Miniature ou fichier trop compressé',
      blurFix: 'Reprendre le fichier appareil photo ou une version plus haute définition',
      troubleTipTitle: 'Priorité au nouvel essai',
      troubleTipText: 'Halo blanc, cheveux manquants ou verre incomplet : améliorez la source plutôt que de renvoyer la même image basse définition.',
      intentsTitle: 'Cas d’usage fréquents',
      extraScenarios: [
        { title: 'Détourage gratuit en ligne', text: 'Uploadez JPG / PNG / WebP, laissez la détection automatique, puis téléchargez le PNG transparent.' },
        { title: 'Détourage des cheveux', text: 'Utilisez un original net et vérifiez les mèches fines sur un fond clair et un fond sombre.' },
        { title: 'Corriger un liseré blanc', text: 'Placez le PNG sur un fond sombre et réessayez avec une source plus contrastée.' },
        { title: 'Détourer sans Photoshop', text: 'Pas de plume à tracer : l’IA détecte le sujet et retire tout l’arrière-plan.' },
        { title: 'Passer un JPG en PNG transparent', text: 'Le JPG ne stocke pas la transparence. Enregistrez toujours en PNG après suppression.' },
        { title: 'Transparent vs fond blanc', text: 'Un PNG transparent n’a pas de couleur fixe ; une image à fond blanc contient déjà des pixels blancs.' },
        { title: 'Photo smartphone', text: 'Préférez le fichier caméra. Les miniatures de messagerie gênent cheveux et verre.' },
        { title: 'Fond de photo d’identité', text: 'Créez d’abord le PNG transparent, puis ajoutez le blanc ou la couleur exigée.' },
        { title: 'Fichier de plus de 15 Mo', text: 'Compressez avant l’envoi. La page traite une image à la fois.' }
      ]
    }),
    ecomStruct({
      freeLabel: 'Traitement gratuit',
      freeKeep: 'Se connecter puis utiliser Miral AI Background Remover',
      freeCheck: 'Aucun logiciel à installer ; créer d’abord le PNG transparent maître',
      galleryCaption: 'Avant / après sur un visuel produit. Le PNG transparent sert de master pour fond blanc et scènes.',
      indieLabel: 'Site propre / cross-border',
      indieUse: 'Fiches produit multilingues et visuels pub',
      indieNote: 'Dériver les formats depuis un seul PNG transparent',
      platTipTitle: 'Règles des plateformes',
      platTipText: 'La suppression prépare un fichier propre, elle ne garantit pas la conformité. Vérifiez les règles officielles du canal avant publication.',
      casesP: 'Chaque matière échoue ailleurs : vêtements (fil), bijoux (chaînes), verre (zones transparentes), électronique (ports et reflets). Ne jugez pas sur la miniature : zoomez à 100 % sur fond clair et foncé.',
      acceptTipTitle: 'Gérer le master',
      acceptTipText: 'Pour unifier le fond boutique, archivez d’abord le PNG transparent. Blanc, couleur de marque et scènes saisonnières partent de ce fichier.',
      intentsTitle: 'Cas d’usage fréquents',
      extraScenarios: [
        { title: 'Verre incomplet', text: 'Changez pour une source plus contrastée et contrôlez les zones transparentes sur blanc et sombre.' },
        { title: 'Liseré blanc sur un produit', text: 'Placez le PNG sur un fond sombre, puis réessayez avec une photo produit plus nette et contrastée.' },
        { title: 'Un PNG pour plusieurs marketplaces', text: 'Partagez le master, exportez taille, marges et fond par canal.' },
        { title: 'Du détourage à la scène lifestyle', text: 'Passez le PNG dans Seedream ou FLUX et vérifiez forme, couleur et logo.' },
        { title: 'Catalogue en lot ?', text: 'Une image à la fois. Chaînes, verre et fourrure demandent une revue individuelle.' },
        { title: 'Vêtements et lacets', text: 'Suivez le contour et les lacets croisés pour éviter de couper le mesh ou les lacets.' },
        { title: 'Master blanc vs transparent', text: 'Gardez d’abord le master transparent. Ajoutez le blanc en export séparé ; n’écrasez pas le PNG.' }
      ]
    }),
    kw(
      ['suppression d’arrière-plan IA gratuite', 'détourage en ligne', 'PNG transparent', 'fond portrait', 'cheveux détourage', 'logo fond transparent'],
      ['fond produit ecommerce', 'fond blanc Amazon', 'image Shopify transparente', 'détourage eBay', 'fond Etsy', 'PNG produit']
    )
  ),
  es: extras(
    bgStruct({
      bestForLabel: 'Ideal para',
      bestForValue: 'Retratos, avatares, productos, logos, firmas, fotos de mascotas',
      galleryCaption: 'Izquierda, original; derecha, ejemplo sin fondo. El archivo final se descarga como PNG transparente.',
      howTipTitle: 'Conservar bordes nítidos',
      howTipText: 'Sube el original, no una imagen recomprimida. Miniaturas, movimiento y colores similares dificultan el borde.',
      blurLabel: 'El resultado se ve borroso',
      blurCause: 'Miniatura o archivo muy comprimido',
      blurFix: 'Volver al archivo de cámara o a una versión de mayor resolución',
      troubleTipTitle: 'Clave al reintentar',
      troubleTipText: 'Halo blanco, pelo perdido u objeto de cristal incompleto: mejora la fuente en lugar de repetir el mismo archivo de baja calidad.',
      intentsTitle: 'Escenarios frecuentes',
      extraScenarios: [
        { title: 'Recorte gratis online', text: 'Sube JPG / PNG / WebP, deja la detección automática y descarga el PNG transparente.' },
        { title: 'Recorte de pelo', text: 'Usa un original nítido y revisa hebras finas sobre un lienzo claro y uno oscuro.' },
        { title: 'Corregir borde blanco', text: 'Pon el PNG sobre un lienzo oscuro y reintenta con un original más contrastado.' },
        { title: 'Recortar sin Photoshop', text: 'No hace falta pluma: la IA detecta el sujeto y quita todo el fondo.' },
        { title: 'De JPG a PNG transparente', text: 'JPG no guarda transparencia. Guarda siempre en PNG después de quitar el fondo.' },
        { title: 'Transparente vs fondo blanco', text: 'Un PNG transparente no tiene color fijo; una imagen de fondo blanco ya contiene píxeles blancos.' },
        { title: 'Foto de móvil', text: 'Usa el archivo de cámara. Las miniaturas de chat perjudican pelo y cristal.' },
        { title: 'Fondo de foto de carnet', text: 'Crea primero el PNG transparente y luego añade blanco o el color pedido.' },
        { title: 'Archivo de más de 15 MB', text: 'Comprime antes de subir. La página procesa una imagen cada vez.' }
      ]
    }),
    ecomStruct({
      freeLabel: 'Proceso gratuito',
      freeKeep: 'Inicia sesión y usa Miral AI Background Remover',
      freeCheck: 'Sin software extra; primero el PNG transparente maestro',
      galleryCaption: 'Antes y después del recorte de producto. El PNG transparente es el master para fondo blanco y escenas.',
      indieLabel: 'Tienda propia / cross-border',
      indieUse: 'Fichas multilingües e imágenes publicitarias',
      indieNote: 'Derivar tamaños desde un solo PNG transparente',
      platTipTitle: 'Normas de las plataformas',
      platTipText: 'Quitar el fondo prepara el archivo; no certifica el cumplimiento. Revisa las normas oficiales del canal antes de publicar.',
      casesP: 'Cada material falla en un sitio distinto: ropa (pelusa), joyas (cadenas), cristal (zonas transparentes), electrónica (puertos y reflejos). No te fíes de la miniatura: revisa al 100 % sobre fondos claro y oscuro.',
      acceptTipTitle: 'Gestionar el master',
      acceptTipText: 'Para unificar el fondo de la tienda, guarda primero el PNG transparente. Blanco, color de marca y escenas salen de ese archivo.',
      intentsTitle: 'Escenarios frecuentes',
      extraScenarios: [
        { title: 'Cristal incompleto', text: 'Cambia a un original más contrastado y revisa las zonas transparentes en blanco y oscuro.' },
        { title: 'Borde blanco en el recorte', text: 'Pon el PNG sobre un lienzo oscuro y reintenta con una foto de producto más nítida y contrastada.' },
        { title: 'Un PNG para varios marketplaces', text: 'Comparte el master y exporta recorte, márgenes y fondo por canal.' },
        { title: 'Del recorte a la escena lifestyle', text: 'Pasa el PNG a Seedream o FLUX y verifica forma, color y logo.' },
        { title: '¿Catálogo por lotes?', text: 'Ahora es una imagen por vez. Cadenas, cristal y pelaje requieren revisión individual.' },
        { title: 'Ropa y cordones', text: 'Sigue el contorno y los cordones cruzados para que no se recorten malla o cordones.' },
        { title: 'Master blanco vs transparente', text: 'Guarda primero el master transparente. Añade el blanco solo como exportación aparte; no lo sobrescribas.' }
      ]
    }),
    kw(
      ['eliminador de fondo IA gratis', 'recorte online', 'PNG transparente', 'fondo retrato', 'pelo recorte', 'logo fondo transparente'],
      ['fondo producto ecommerce', 'fondo blanco Amazon', 'imagen Shopify transparente', 'recorte eBay', 'fondo Etsy', 'PNG producto']
    )
  ),
  it: extras(
    bgStruct({
      bestForLabel: 'Ideale per',
      bestForValue: 'Ritratti, avatar, prodotti, logo, firme, foto di animali',
      galleryCaption: 'A sinistra l’originale, a destra l’esempio dopo la rimozione. Il file finale si scarica come PNG trasparente.',
      howTipTitle: 'Mantenere bordi nitidi',
      howTipText: 'Carica l’originale, non un file ricompresso. Miniature, mosso e colori simili rendono i bordi più difficili.',
      blurLabel: 'Il risultato sembra sfocato',
      blurCause: 'Miniatura o file troppo compresso',
      blurFix: 'Tornare al file della fotocamera o a una versione a risoluzione più alta',
      troubleTipTitle: 'Priorità al nuovo tentativo',
      troubleTipText: 'Alone bianco, capelli persi o vetro incompleto: migliora la fonte invece di rinviare lo stesso file a bassa qualità.',
      intentsTitle: 'Scenari frequenti',
      extraScenarios: [
        { title: 'Ritaglio gratis online', text: 'Carica JPG / PNG / WebP, lascia il rilevamento automatico e scarica il PNG trasparente.' },
        { title: 'Ritaglio dei capelli', text: 'Usa un originale nitido e controlla i capelli sottili su una tela chiara e una scura.' },
        { title: 'Correggere il bordo bianco', text: 'Metti il PNG su una tela scura e riprova con un originale più contrastato.' },
        { title: 'Ritagliare senza Photoshop', text: 'Niente penna: l’IA trova il soggetto e toglie tutto lo sfondo.' },
        { title: 'Da JPG a PNG trasparente', text: 'JPG non conserva la trasparenza. Salva sempre in PNG dopo la rimozione.' },
        { title: 'Trasparente vs fondo bianco', text: 'Un PNG trasparente non ha un colore fisso; un’immagine a fondo bianco contiene già pixel bianchi.' },
        { title: 'Foto da smartphone', text: 'Usa il file della fotocamera. Le miniature delle chat penalizzano capelli e vetro.' },
        { title: 'Sfondo foto tessera', text: 'Crea prima il PNG trasparente, poi aggiungi il bianco o il colore richiesto.' },
        { title: 'File oltre 15 MB', text: 'Comprimi prima del caricamento. La pagina elabora un’immagine alla volta.' }
      ]
    }),
    ecomStruct({
      freeLabel: 'Elaborazione gratuita',
      freeKeep: 'Accedi e usa Miral AI Background Remover',
      freeCheck: 'Nessun software extra; crea prima il PNG trasparente master',
      galleryCaption: 'Prima e dopo sul prodotto. Il PNG trasparente è il master per fondo bianco e scene.',
      indieLabel: 'Negozio proprio / cross-border',
      indieUse: 'Schede multilingue e creatività ads',
      indieNote: 'Derivare i formati da un solo PNG trasparente',
      platTipTitle: 'Regole delle piattaforme',
      platTipText: 'La rimozione prepara il file; non certifica la conformità. Controlla i requisiti ufficiali del canale prima di pubblicare.',
      casesP: 'Ogni materiale fallisce in un punto diverso: abiti (filamenti), gioielli (catene), vetro (zone trasparenti), elettronica (porte e riflessi). Non giudicare dalla miniatura: zoom al 100% su fondi chiaro e scuro.',
      acceptTipTitle: 'Gestire il master',
      acceptTipText: 'Per uniformare lo sfondo dello store, archivia prima il PNG trasparente. Bianco, colore brand e scene stagionali partono da quel file.',
      intentsTitle: 'Scenari frequenti',
      extraScenarios: [
        { title: 'Vetro incompleto', text: 'Passa a un originale più contrastato e rivedi le zone trasparenti su bianco e scuro.' },
        { title: 'Bordo bianco sul ritaglio', text: 'Metti il PNG su una tela scura e riprova con una foto prodotto più nitida e contrastata.' },
        { title: 'Un PNG per più marketplace', text: 'Condividi il master; esporta taglio, margini e fondo per canale.' },
        { title: 'Dal ritaglio alla scena lifestyle', text: 'Passa il PNG a Seedream o FLUX e verifica forma, colore e logo.' },
        { title: 'Catalogo in batch?', text: 'Ora è un’immagine alla volta. Catene, vetro e pelo vanno rivisti uno per uno.' },
        { title: 'Abbigliamento e lacci', text: 'Segui il contorno e i lacci che si incrociano perché rete o lacci non vengano tagliati.' },
        { title: 'Master bianco vs trasparente', text: 'Tieni prima il master trasparente. Aggiungi il bianco solo come export separato; non sovrascrivere il PNG.' }
      ]
    }),
    kw(
      ['rimozione sfondo IA gratis', 'ritaglio online', 'PNG trasparente', 'sfondo ritratto', 'capelli ritaglio', 'logo sfondo trasparente'],
      ['sfondo prodotto ecommerce', 'fondo bianco Amazon', 'immagine Shopify trasparente', 'ritaglio eBay', 'sfondo Etsy', 'PNG prodotto']
    )
  ),
  de: extras(
    bgStruct({
      bestForLabel: 'Geeignet für',
      bestForValue: 'Porträts, Avatare, Produkte, Logos, Unterschriften, Haustierfotos',
      galleryCaption: 'Links das Original, rechts das Beispiel nach der Entfernung. Die Datei wird als transparentes PNG heruntergeladen.',
      howTipTitle: 'Scharfe Kanten behalten',
      howTipText: 'Laden Sie das Original hoch, keine mehrfach komprimierte Datei. Miniaturen, Unschärfe und ähnliche Farben erschweren die Kante.',
      blurLabel: 'Das Ergebnis wirkt unscharf',
      blurCause: 'Miniatur oder stark komprimierte Datei',
      blurFix: 'Kameradatei oder eine höher aufgelöste Version verwenden',
      troubleTipTitle: 'Fokus beim erneuten Versuch',
      troubleTipText: 'Weißer Rand, fehlende Haare oder unvollständiges Glas: Verbessern Sie die Quelle statt dieselbe Low-Res-Datei erneut zu senden.',
      intentsTitle: 'Häufige Szenarien',
      extraScenarios: [
        { title: 'Kostenlos online freistellen', text: 'JPG / PNG / WebP hochladen, automatisch erkennen lassen und das transparente PNG laden.' },
        { title: 'Haare freistellen', text: 'Nutzen Sie ein scharfes Original und prüfen Sie feine Strähnen auf hellem und dunklem Hintergrund.' },
        { title: 'Weißen Rand korrigieren', text: 'PNG auf dunkle Fläche legen und mit kontraststärkerem Original erneut versuchen.' },
        { title: 'Freistellen ohne Photoshop', text: 'Kein Pfad nötig: Die KI findet das Motiv und entfernt den gesamten Hintergrund.' },
        { title: 'JPG zu transparentem PNG', text: 'JPG speichert keine Transparenz. Nach der Entfernung immer als PNG sichern.' },
        { title: 'Transparent vs Weißhintergrund', text: 'Ein transparentes PNG hat keine feste Farbe; ein Weißhintergrundbild enthält bereits weiße Pixel.' },
        { title: 'Handyfoto freistellen', text: 'Wenn möglich die Kameradatei nutzen. Chat-Miniaturen schaden Haaren und Glas.' },
        { title: 'Passbild-Hintergrund', text: 'Zuerst das transparente PNG erzeugen, danach Weiß oder die geforderte Farbe legen.' },
        { title: 'Datei über 15 MB', text: 'Zuerst komprimieren. Die Seite verarbeitet jeweils ein Bild.' }
      ]
    }),
    ecomStruct({
      freeLabel: 'Kostenlose Verarbeitung',
      freeKeep: 'Anmelden und Miral AI Background Remover nutzen',
      freeCheck: 'Keine Extra-Software; zuerst das transparente PNG-Master anlegen',
      galleryCaption: 'Vorher/nachher am Produkt. Das transparente PNG ist Master für Weißhintergrund und Szenen.',
      indieLabel: 'Eigener Shop / Cross-Border',
      indieUse: 'Mehrsprachige Produktseiten und Anzeigenmotive',
      indieNote: 'Formate von einem transparenten PNG-Master ableiten',
      platTipTitle: 'Plattformregeln',
      platTipText: 'Die Freistellung liefert sauberes Material, keine automatische Compliance. Prüfen Sie vor der Veröffentlichung die offiziellen Kanalregeln.',
      casesP: 'Jedes Material scheitert woanders: Kleidung (Fasern), Schmuck (Ketten), Glas (Transparenz), Elektronik (Ports und Spiegelungen). Nicht nur das Thumbnail prüfen – 100 % auf hell und dunkel kontrollieren.',
      acceptTipTitle: 'Master verwalten',
      acceptTipText: 'Für einheitliche Shop-Hintergründe zuerst das transparente PNG archivieren. Weiß, Markenfarbe und Kampagnenszenen entstehen daraus.',
      intentsTitle: 'Häufige Szenarien',
      extraScenarios: [
        { title: 'Glas unvollständig', text: 'Kontraststärkeres Original wählen und transparente Zonen auf Weiß und Dunkel prüfen.' },
        { title: 'Weißer Rand am Produktcutout', text: 'PNG auf dunkle Fläche legen und mit einem schärferen, kontraststärkeren Produktfoto erneut versuchen.' },
        { title: 'Ein PNG für mehrere Marktplätze', text: 'Master teilen, Zuschnitt, Abstand und Hintergrund je Kanal exportieren.' },
        { title: 'Vom Cutout zur Lifestyle-Szene', text: 'PNG in Seedream oder FLUX geben und Form, Farbe und Logo prüfen.' },
        { title: 'Katalog als Batch?', text: 'Derzeit ein Bild nach dem anderen. Ketten, Glas und Fell einzeln prüfen.' },
        { title: 'Kleidung und Schnürsenkel', text: 'Kontur und kreuzende Schnürsenkel prüfen, damit Netz oder Schnürsenkel nicht abgeschnitten werden.' },
        { title: 'Weiß vs transparenter Master', text: 'Zuerst den transparenten Master behalten. Weiß nur als separaten Export hinzufügen; das PNG nicht überschreiben.' }
      ]
    }),
    kw(
      ['kostenloser KI-Hintergrundentferner', 'online freistellen', 'transparentes PNG', 'Porträt freistellen', 'Haare freistellen', 'Logo Hintergrund entfernen'],
      ['Produkthintergrund entfernen', 'Amazon Weißhintergrund', 'Shopify transparentes Produktbild', 'eBay Freisteller', 'Etsy Hintergrund', 'Produkt-PNG']
    )
  ),
  pt: extras(
    bgStruct({
      bestForLabel: 'Ideal para',
      bestForValue: 'Retratos, avatares, produtos, logos, assinaturas, fotos de pets',
      galleryCaption: 'À esquerda o original, à direita o exemplo após remover o fundo. O arquivo final baixa como PNG transparente.',
      howTipTitle: 'Manter bordas nítidas',
      howTipText: 'Envie o original, não um arquivo recomprimido. Miniaturas, desfoque e cores parecidas dificultam a borda.',
      blurLabel: 'O resultado parece desfocado',
      blurCause: 'Miniatura ou arquivo muito comprimido',
      blurFix: 'Voltar ao arquivo da câmera ou a uma versão de maior resolução',
      troubleTipTitle: 'Foco na nova tentativa',
      troubleTipText: 'Halo branco, cabelo perdido ou vidro incompleto: melhore a origem em vez de reenviar o mesmo arquivo de baixa qualidade.',
      intentsTitle: 'Cenários frequentes',
      extraScenarios: [
        { title: 'Recorte grátis online', text: 'Envie JPG / PNG / WebP, deixe a detecção automática e baixe o PNG transparente.' },
        { title: 'Recorte de cabelo', text: 'Use um original nítido e confira fios finos em um fundo claro e um escuro.' },
        { title: 'Corrigir borda branca', text: 'Coloque o PNG num fundo escuro e tente de novo com um original mais contrastado.' },
        { title: 'Recortar sem Photoshop', text: 'Sem pen tool: a IA encontra o sujeito e remove o fundo inteiro.' },
        { title: 'De JPG para PNG transparente', text: 'JPG não guarda transparência. Salve sempre em PNG depois da remoção.' },
        { title: 'Transparente vs fundo branco', text: 'Um PNG transparente não tem cor fixa; uma imagem de fundo branco já contém pixels brancos.' },
        { title: 'Foto de celular', text: 'Use o arquivo da câmera. Miniaturas de chat prejudicam cabelo e vidro.' },
        { title: 'Fundo de foto 3x4', text: 'Crie primeiro o PNG transparente e depois acrescente branco ou a cor pedida.' },
        { title: 'Arquivo acima de 15 MB', text: 'Comprima antes do envio. A página processa uma imagem por vez.' }
      ]
    }),
    ecomStruct({
      freeLabel: 'Processamento gratuito',
      freeKeep: 'Entrar e usar o Miral AI Background Remover',
      freeCheck: 'Sem software extra; primeiro o PNG transparente mestre',
      galleryCaption: 'Antes e depois no produto. O PNG transparente é o master para fundo branco e cenas.',
      indieLabel: 'Loja própria / cross-border',
      indieUse: 'Páginas de produto multilíngues e anúncios',
      indieNote: 'Derivar tamanhos a partir de um único PNG transparente',
      platTipTitle: 'Regras das plataformas',
      platTipText: 'Remover o fundo prepara o arquivo; não garante conformidade. Confira as regras oficiais do canal antes de publicar.',
      casesP: 'Cada material falha em um ponto: roupa (fiapos), joias (correntes), vidro (áreas transparentes), eletrônicos (portas e reflexos). Não julgue pela miniatura: veja em 100% sobre fundos claro e escuro.',
      acceptTipTitle: 'Gerir o master',
      acceptTipText: 'Para unificar o fundo da loja, arquive primeiro o PNG transparente. Branco, cor da marca e cenas saem desse arquivo.',
      intentsTitle: 'Cenários frequentes',
      extraScenarios: [
        { title: 'Vidro incompleto', text: 'Troque por um original mais contrastado e revise as áreas transparentes no branco e no escuro.' },
        { title: 'Borda branca no recorte', text: 'Coloque o PNG num fundo escuro e tente de novo com uma foto de produto mais nítida e contrastada.' },
        { title: 'Um PNG para vários marketplaces', text: 'Compartilhe o master e exporte corte, margem e fundo por canal.' },
        { title: 'Do recorte à cena lifestyle', text: 'Leve o PNG ao Seedream ou FLUX e confira forma, cor e logo.' },
        { title: 'Catálogo em lote?', text: 'Agora é uma imagem por vez. Correntes, vidro e pelos pedem revisão individual.' },
        { title: 'Roupas e cadarços', text: 'Siga o contorno e os cadarços cruzados para não cortar malha ou cadarços.' },
        { title: 'Master branco vs transparente', text: 'Guarde primeiro o master transparente. Adicione o branco só como exportação separada; não sobrescreva o PNG.' }
      ]
    }),
    kw(
      ['removedor de fundo IA grátis', 'recorte online', 'PNG transparente', 'fundo retrato', 'cabelo recorte', 'logo fundo transparente'],
      ['fundo de produto ecommerce', 'fundo branco Amazon', 'imagem Shopify transparente', 'recorte eBay', 'fundo Etsy', 'PNG de produto']
    )
  ),
  pl: extras(
    bgStruct({
      bestForLabel: 'Najlepsze do',
      bestForValue: 'Portrety, avatary, produkty, logotypy, podpisy, zdjęcia zwierząt',
      galleryCaption: 'Po lewej oryginał, po prawej przykład po usunięciu tła. Plik końcowy pobiera się jako przezroczyste PNG.',
      howTipTitle: 'Zachować ostre krawędzie',
      howTipText: 'Wgraj oryginał, nie plik wielokrotnie kompresowany. Miniatury, poruszenie i podobne kolory utrudniają krawędź.',
      blurLabel: 'Wynik wygląda na rozmyty',
      blurCause: 'Miniatura lub mocno skompresowany plik',
      blurFix: 'Wrócić do pliku z aparatu lub wersji o wyższej rozdzielczości',
      troubleTipTitle: 'Priorytet przy ponownej próbie',
      troubleTipText: 'Biała obwódka, zniknięte włosy lub niepełne szkło: popraw źródło zamiast wysyłać ten sam plik niskiej jakości.',
      intentsTitle: 'Częste scenariusze',
      extraScenarios: [
        { title: 'Darmowe wycinanie online', text: 'Wgraj JPG / PNG / WebP, pozwól na automatyczne wykrycie i pobierz przezroczyste PNG.' },
        { title: 'Wycinanie włosów', text: 'Użyj ostrego oryginału i sprawdź cienkie pasma na jasnym i ciemnym tle.' },
        { title: 'Poprawić białą obwódkę', text: 'Połóż PNG na ciemnym tle i spróbuj ponownie z bardziej kontrastowym oryginałem.' },
        { title: 'Wycinanie bez Photoshopa', text: 'Bez pióra: AI znajduje obiekt i usuwa całe tło.' },
        { title: 'Z JPG do przezroczystego PNG', text: 'JPG nie zapisuje przezroczystości. Po usunięciu zawsze zapisuj PNG.' },
        { title: 'Przezroczyste vs białe tło', text: 'Przezroczyste PNG nie ma stałego koloru; obraz z białym tłem już zawiera białe piksele.' },
        { title: 'Zdjęcie z telefonu', text: 'Użyj pliku z aparatu. Miniatury z czatu psują włosy i szkło.' },
        { title: 'Tło zdjęcia do dokumentów', text: 'Najpierw zrób przezroczyste PNG, potem dodaj biel lub wymagany kolor.' },
        { title: 'Plik powyżej 15 MB', text: 'Najpierw skompresuj. Strona przetwarza jeden obraz naraz.' }
      ]
    }),
    ecomStruct({
      freeLabel: 'Darmowe przetwarzanie',
      freeKeep: 'Zaloguj się i użyj Miral AI Background Remover',
      freeCheck: 'Bez dodatkowego oprogramowania; najpierw przezroczysty PNG master',
      galleryCaption: 'Przed i po na produkcie. Przezroczyste PNG to master pod białe tło i sceny.',
      indieLabel: 'Własny sklep / cross-border',
      indieUse: 'Wielojęzyczne karty produktu i reklamy',
      indieNote: 'Pochodne rozmiary z jednego przezroczystego PNG',
      platTipTitle: 'Zasady platform',
      platTipText: 'Usunięcie tła przygotowuje plik, nie gwarantuje zgodności. Przed publikacją sprawdź oficjalne wymagania kanału.',
      casesP: 'Każdy materiał psuje się gdzie indziej: ubrania (włoski), biżuteria (łańcuszki), szkło (przeźroczystość), elektronika (porty i odbicia). Nie oceniaj miniatury – sprawdzaj w 100% na jasnym i ciemnym tle.',
      acceptTipTitle: 'Zarządzanie masterem',
      acceptTipText: 'Aby ujednolicić tło sklepu, najpierw zapisz czyste przezroczyste PNG. Biel, kolor marki i sceny kampanii wychodzą z tego pliku.',
      intentsTitle: 'Częste scenariusze',
      extraScenarios: [
        { title: 'Niepełne szkło', text: 'Zmień na bardziej kontrastowy oryginał i sprawdź strefy przezroczyste na bieli i ciemnym tle.' },
        { title: 'Biała obwódka na wycinance', text: 'Połóż PNG na ciemnym tle i spróbuj ponownie z ostrzejszym, bardziej kontrastowym zdjęciem produktu.' },
        { title: 'Jedno PNG na wiele marketplace’ów', text: 'Współdziel master, eksportuj kadr, marginesy i tło per kanał.' },
        { title: 'Od wycinanki do sceny lifestyle', text: 'Przekaż PNG do Seedream lub FLUX i sprawdź kształt, kolor i logo.' },
        { title: 'Katalog hurtowo?', text: 'Na razie jeden obraz naraz. Łańcuszki, szkło i futro sprawdzaj pojedynczo.' },
        { title: 'Odzież i sznurówki', text: 'Śledź kontur i krzyżujące się sznurówki, żeby siatka lub sznurówki nie zostały obcięte.' },
        { title: 'Biały vs przezroczysty master', text: 'Najpierw zachowaj przezroczysty master. Biel dodawaj tylko jako osobny eksport; nie nadpisuj PNG.' }
      ]
    }),
    kw(
      ['darmowe usuwanie tła AI', 'wycinanie online', 'przezroczyste PNG', 'tło portretu', 'włosy wycinanie', 'logo bez tła'],
      ['tło zdjęcia produktu', 'białe tło Amazon', 'przezroczyste zdjęcie Shopify', 'wycinanie eBay', 'tło Etsy', 'PNG produktu']
    )
  ),
  ar: extras(
    bgStruct({
      bestForLabel: 'الأنسب لـ',
      bestForValue: 'صور شخصية، أفاتار، منتجات، شعارات، توقيعات، صور حيوانات أليفة',
      galleryCaption: 'اليسار الأصل واليمين مثال بعد إزالة الخلفية. يُنزَّل الملف النهائي كـ PNG شفاف.',
      howTipTitle: 'الحفاظ على حواف حادة',
      howTipText: 'ارفع الملف الأصلي لا صورة مضغوطة مراراً. المصغرات والضبابية والألوان المتشابهة تصعّب الحافة.',
      blurLabel: 'النتيجة تبدو ضبابية',
      blurCause: 'مصغّر أو ملف مضغوط بشدة',
      blurFix: 'العودة إلى ملف الكاميرا أو نسخة أعلى دقة',
      troubleTipTitle: 'أولوية إعادة المحاولة',
      troubleTipText: 'هالة بيضاء أو شعر مفقود أو زجاج ناقص: حسّن المصدر بدل إعادة إرسال الملف منخفض الجودة.',
      intentsTitle: 'سيناريوهات شائعة',
      extraScenarios: [
        { title: 'قص مجاني عبر الإنترنت', text: 'ارفع JPG / PNG / WebP ودع الاكتشاف التلقائي ثم نزّل PNG الشفاف.' },
        { title: 'قص الشعر', text: 'استخدم أصلاً حاداً وافحص الخصل الرفيعة على لوحة فاتحة وأخرى داكنة.' },
        { title: 'إصلاح الحافة البيضاء', text: 'ضع PNG على لوحة داكنة وأعد المحاولة بأصل أعلى تبايناً.' },
        { title: 'قص دون فوتوشوب', text: 'لا حاجة لأداة القلم: يكتشف الذكاء الاصطناعي الموضوع ويزيل الخلفية بالكامل.' },
        { title: 'من JPG إلى PNG شفاف', text: 'JPG لا يحفظ الشفافية. احفظ دائماً كـ PNG بعد الإزالة.' },
        { title: 'الشفاف مقابل الخلفية البيضاء', text: 'PNG الشفاف بلا لون ثابت؛ صورة الخلفية البيضاء تحتوي بالفعل بكسلات بيضاء.' },
        { title: 'صورة من الهاتف', text: 'استخدم ملف الكاميرا. مصغرات الدردشة تضر الشعر والزجاج.' },
        { title: 'خلفية صورة رسمية', text: 'أنشئ PNG الشفاف أولاً ثم أضف الأبيض أو اللون المطلوب.' },
        { title: 'ملف أكبر من 15MB', text: 'اضغط أولاً. الصفحة تعالج صورة واحدة في كل مرة.' }
      ]
    }),
    ecomStruct({
      freeLabel: 'معالجة مجانية',
      freeKeep: 'سجّل الدخول واستخدم Miral AI Background Remover',
      freeCheck: 'بدون برنامج إضافي؛ أنشئ أولاً PNG الشفاف الرئيسي',
      galleryCaption: 'قبل وبعد على صورة المنتج. PNG الشفاف هو الأصل للخلفية البيضاء والمشاهد.',
      indieLabel: 'متجر خاص / عبر الحدود',
      indieUse: 'صفحات منتج متعددة اللغات وصور إعلانات',
      indieNote: 'اشتقاق الأحجام من PNG شفاف واحد',
      platTipTitle: 'قواعد المنصات',
      platTipText: 'إزالة الخلفية تجهّز ملفاً نظيفاً ولا تضمن الامتثال. راجع المتطلبات الرسمية للقناة قبل النشر.',
      casesP: 'كل خامة تفشل في موضع مختلف: الملابس (الوبر)، المجوهرات (السلاسل)، الزجاج (المناطق الشفافة)، الإلكترونيات (المنافذ والانعكاس). لا تعتمد على المصغّر: افحص عند 100٪ على خلفية فاتحة وداكنة.',
      acceptTipTitle: 'إدارة الملف الأصلي',
      acceptTipText: 'لتوحيد خلفية المتجر احفظ أولاً PNG الشفاف النظيف. الأبيض ولون العلامة ومشاهد الحملة تُشتق منه.',
      intentsTitle: 'سيناريوهات شائعة',
      extraScenarios: [
        { title: 'زجاج ناقص', text: 'بدّل إلى أصل أعلى تبايناً وراجع المناطق الشفافة على أبيض وداكن.' },
        { title: 'هالة بيضاء حول قص المنتج', text: 'ضع PNG على لوحة داكنة ثم أعد المحاولة بصورة منتج أوضح وأعلى تبايناً.' },
        { title: 'PNG واحد لعدة أسواق', text: 'شارك الأصل وصدر القص والهوامش والخلفية لكل قناة.' },
        { title: 'من القص إلى مشهد أسلوب حياة', text: 'انقل PNG إلى Seedream أو FLUX وتحقق من الشكل واللون والشعار.' },
        { title: 'كتالوج دفعة واحدة؟', text: 'حالياً صورة واحدة في كل مرة. السلاسل والزجاج والفراء تحتاج مراجعة فردية.' },
        { title: 'الملابس والأربطة', text: 'اتبع المحيط والأربطة المتقاطعة حتى لا تُقص الشبكة أو الرباطات.' },
        { title: 'الأبيض مقابل الأصل الشفاف', text: 'احتفظ أولاً بالأصل الشفاف. أضف الأبيض كملف منفصل ولا تستبدل PNG.' }
      ]
    }),
    kw(
      ['إزالة خلفية بالذكاء الاصطناعي مجاناً', 'قص صور أونلاين', 'PNG شفاف', 'إزالة خلفية البورتريه', 'قص الشعر', 'إزالة خلفية الشعار'],
      ['إزالة خلفية صورة المنتج', 'خلفية بيضاء Amazon', 'صورة Shopify شفافة', 'قص eBay', 'خلفية Etsy', 'PNG منتج']
    )
  )
}
